import React, { useMemo } from "react";

import { defineMessages, useIntl } from "react-intl";

import IntegrationService from "@mapmycustomers/shared/enum/integrations/IntegrationService";
import { EntityTypesSupportedByIntegrations } from "@mapmycustomers/shared/types/entity";
import { Alert } from "@mapmycustomers/ui";

import { getEntityTypeDisplayName } from "@app/util/ui";

import getEntityRequiredFieldsForIntegration from "../../utils/getEntityRequiredFieldsForIntegration";

import styles from "./Steps.module.scss";

const messages = defineMessages({
  info: {
    id: "integrations.requiredFieldsInfo.text",
    defaultMessage: "<b>{fields}</b> is required for syncing with {entityType}.",
    description: "Integration required fields",
  },
});

interface Props {
  entityType: EntityTypesSupportedByIntegrations;
  service?: IntegrationService;
}

const RequiredFieldsInfo: React.FC<Props> = ({ entityType, service }) => {
  const intl = useIntl();

  const text = useMemo(() => {
    const fields = getEntityRequiredFieldsForIntegration(entityType, service)
      .map(({ displayName }) => displayName)
      .join(", ");
    return intl.formatMessage(messages.info, {
      b: (text) => <b>{text}</b>,
      entityType: getEntityTypeDisplayName(intl, entityType, { lowercase: false, plural: true }),
      fields,
    });
  }, [entityType, intl, service]);
  return <Alert className={styles.requiredFieldsInfo} message={text} />;
};

export default RequiredFieldsInfo;
